import { Grid } from "@material-ui/core";

import { END_DATE, START_DATE } from "../../../types/templates/brief-fields.constants";
import { TemplateName } from "../../../types/templates/template-name";
import { useWorkOrderTemplateOptions } from "../../../pages/work-order/types/work-order-template.hooks";
import { WORK_ORDER_HOOK } from "../../../pages/work-order/types/work-order-template.interface";
import { WORK_ORDER_TEMPLATE } from "../../../types/templates/work-order/work-order-template.enum";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { DateField } from "../../forms/fields/date-field/date-field.component";
import { RichTextField } from "../../forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { SelectFieldArray } from "../../forms/fields/select-field-array/select-field-array.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";

import {
  CTA,
  DUE_AT,
  FILE_FORMAT_DESCRIPTION,
  IS_BUY_GET,
  IS_CREATIVE_REVIEW_REQUIRED,
  IS_SEGMENTED,
  LEGAL,
  NOTES_FOR_CREATIVE,
  NOTES_FOR_ECOMM,
  PRIMARY_MESSAGE,
  SECONDARY_MESSAGE,
  SEGMENTS,
  SITE_PLACEMENT,
} from "../constants";

import { SizeFields } from "./web/components/size-fields/size-fields.component";
import { useSizeFieldsStyles } from "./web/components/size-fields/size-fields.styles";
import { UserSearchFieldSelection } from "./common/user-search-field-selection/user-search-field-selection.component";
import { IWorkOrderTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const WorkOrderWebTemplate = (props: IWorkOrderTemplate) => {
  const {
    assetTypeDimensionList,
    fileFormatOptions,
    positionsOptions,
  } = useWorkOrderTemplateOptions(
    [WORK_ORDER_HOOK.ASSET_TYPES, WORK_ORDER_HOOK.FILE_FORMATS, WORK_ORDER_HOOK.POSITIONS],
    WORK_ORDER_TEMPLATE.WEB
  );

  const sizeFieldsClasses = useSizeFieldsStyles();

  const appendPosition = (assetType: string) => {
    const { desktopDimensions, mobileDimensions, tabletDimensions } = assetTypeDimensionList.find(
      (type) => type.assetTypeOption.name === assetType
    )!;

    return {
      assetType,
      desktopDimensions,
      mobileDimensions,
      tabletDimensions,
    };
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={PRIMARY_MESSAGE.TITLE}
            name={PRIMARY_MESSAGE.ID}
            subTitle={TemplateName.WorkOrder.Web}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={START_DATE.TITLE}
                name={START_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={END_DATE.TITLE}
                name={END_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
          </Grid>
        </BorderedBlock>
        <BorderedBlock>
          <SelectFieldArray
            appendField={appendPosition}
            form={props.form}
            FieldArrayField={SizeFields}
            fieldArrayFieldWrapperClass={sizeFieldsClasses.container}
            fieldKey="assetType"
            label="Size"
            name="positions"
            options={positionsOptions}
            placeholder="Select asset types"
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={SECONDARY_MESSAGE.TITLE}
            name={SECONDARY_MESSAGE.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={CTA.TITLE}
            name={CTA.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={NOTES_FOR_CREATIVE.TITLE}
            name={NOTES_FOR_CREATIVE.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={LEGAL.TITLE}
            name={LEGAL.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={SITE_PLACEMENT.TITLE}
            name={SITE_PLACEMENT.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={NOTES_FOR_ECOMM.TITLE}
            name={NOTES_FOR_ECOMM.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            label="Assign"
            name="contentCreatorsSelection"
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            SelectionComponent={UserSearchFieldSelection}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <DateField
            form={props.form}
            label={DUE_AT.TITLE}
            name={DUE_AT.ID}
            required
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_CREATIVE_REVIEW_REQUIRED.TITLE}
            name={IS_CREATIVE_REVIEW_REQUIRED.ID}
            userPermissions={props.userPermissions}
          />
          <CheckboxField
            form={props.form}
            label={IS_BUY_GET.TITLE}
            name={IS_BUY_GET.ID}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <SelectField
            form={props.form}
            label="File Format"
            name="fileFormat"
            options={fileFormatOptions}
            userPermissions={props.userPermissions}
          />
          <RichTextField
            form={props.form}
            label={FILE_FORMAT_DESCRIPTION.TITLE}
            name={FILE_FORMAT_DESCRIPTION.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_SEGMENTED.TITLE}
            name={IS_SEGMENTED.ID}
            userPermissions={props.userPermissions}
          >
            <RichTextField
              form={props.form}
              label={SEGMENTS.TITLE}
              name={SEGMENTS.ID}
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
